// Auto-generated resource for Recordings — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const RecordingsKeys = {
  Validations: {
    DoesNotExist: 'Recordings.Validations.DoesNotExist',
    InvalidPractice: 'Recordings.Validations.InvalidPractice',
    UserMismatch: 'Recordings.Validations.UserMismatch',
    AlreadyUploaded: 'Recordings.Validations.AlreadyUploaded',
    InvalidContentType: 'Recordings.Validations.InvalidContentType',
    InvalidSize: 'Recordings.Validations.InvalidSize',
    UploadTooLarge: 'Recordings.Validations.UploadTooLarge',
    InvalidObjectKey: 'Recordings.Validations.InvalidObjectKey',
    InvalidUploadParts: 'Recordings.Validations.InvalidUploadParts',
    InvalidModelKey: 'Recordings.Validations.InvalidModelKey',
    UnsupportedEffort: 'Recordings.Validations.UnsupportedEffort',
    NoRecordingToReview: 'Recordings.Validations.NoRecordingToReview',
    RecordingUnavailable: 'Recordings.Validations.RecordingUnavailable',
    NoRecordingToKeep: 'Recordings.Validations.NoRecordingToKeep',
    ReviewUploadCannotBeSaved: 'Recordings.Validations.ReviewUploadCannotBeSaved',
    SaveRequiresPremium: 'Recordings.Validations.SaveRequiresPremium',
    SelfReviewRequiresPremium: 'Recordings.Validations.SelfReviewRequiresPremium',
    SelfReviewNeedsPlanTake: 'Recordings.Validations.SelfReviewNeedsPlanTake',
    QuotaExceeded: 'Recordings.Validations.QuotaExceeded',
    NoAiCreditsAvailable: 'Recordings.Validations.NoAiCreditsAvailable',
    EmptyName: 'Recordings.Validations.EmptyName',
    NameTooLong: 'Recordings.Validations.NameTooLong',
    NameContainsControlCharacters: 'Recordings.Validations.NameContainsControlCharacters',
    NotesTooLong: 'Recordings.Validations.NotesTooLong',
    InvalidReviewDuration: 'Recordings.Validations.InvalidReviewDuration',
    InvalidThumbnailContentType: 'Recordings.Validations.InvalidThumbnailContentType',
    InvalidThumbnailObjectKey: 'Recordings.Validations.InvalidThumbnailObjectKey',
  },
  Errors: {
    UnknownPractice: 'Recordings.Errors.UnknownPractice',
  },
} as const;

export const RecordingsValues = {
  'default': {
    'Errors.UnknownPractice': 'We could not tell which practice this take belongs to, so it was not saved. Open the practice page and record it again.',
    'Validations.AlreadyUploaded': 'Recording already has a blob uploaded',
    'Validations.DoesNotExist': 'Recording does not exist',
    'Validations.EmptyName': 'Recording name cannot be empty',
    'Validations.InvalidContentType': 'ContentType must be one of: {0}',
    'Validations.InvalidModelKey': 'The selected review model is not available',
    'Validations.InvalidObjectKey': 'ObjectKey is required and must match recordings/<userId>/<recordingId>.<ext>',
    'Validations.InvalidPractice': 'Practice is not a recognised value',
    'Validations.InvalidReviewDuration': 'durationSeconds must be a positive number',
    'Validations.InvalidSize': 'SizeBytes must be a positive byte count',
    'Validations.InvalidThumbnailContentType': 'Thumbnail must be an image (image/jpeg, image/png or image/webp)',
    'Validations.InvalidThumbnailObjectKey': 'Thumbnail object key is required and must match thumbnails/<userId>/<recordingId>.<ext>',
    'Validations.InvalidUploadParts': 'The upload id and part list do not describe a valid upload of this recording.',
    'Validations.NameContainsControlCharacters': 'Recording name cannot contain control characters',
    'Validations.NameTooLong': 'Recording name must be {0} characters or fewer',
    'Validations.NoAiCreditsAvailable': 'You need AI credits to upload a recording for review. Visit /pricing to add credits.',
    'Validations.NoRecordingToKeep': 'Cannot save to your library — the recording has been deleted or was never uploaded',
    'Validations.NoRecordingToReview': 'Cannot start review — recording has no uploaded blob',
    'Validations.NotesTooLong': 'Recording notes must be {0} characters or fewer',
    'Validations.QuotaExceeded': 'This recording is too large for your remaining storage. Free up space or add storage to keep it.',
    'Validations.RecordingUnavailable': 'This recording is no longer available — it has been deleted',
    'Validations.ReviewUploadCannotBeSaved': 'Cannot save to your library — this take was uploaded only for its AI Review and is held temporarily',
    'Validations.SaveRequiresPremium': 'Saving a recording to your library is a Premium feature. Visit /pricing to upgrade.',
    'Validations.SelfReviewNeedsPlanTake': 'Self-review checks are recorded only on takes kept in your mastery plan.',
    'Validations.SelfReviewRequiresPremium': 'Recording a self-review check is a Premium feature. Visit /pricing to upgrade.',
    'Validations.UnsupportedEffort': 'The selected model does not offer that Effort',
    'Validations.UploadTooLarge': 'This recording exceeds the maximum supported upload size.',
    'Validations.UserMismatch': 'You cannot operate on another user\'s recording',
  },
  'vi-VN': {
    'Errors.UnknownPractice': 'Chúng tôi không xác định được lượt tập này thuộc bài luyện nào nên đã không lưu. Hãy mở trang bài luyện và ghi lại.',
    'Validations.AlreadyUploaded': 'Bản thu này đã có tệp được tải lên',
    'Validations.DoesNotExist': 'Bản thu không tồn tại',
    'Validations.EmptyName': 'Tên bản thu không được để trống',
    'Validations.InvalidContentType': 'ContentType phải là một trong các giá trị: {0}',
    'Validations.InvalidModelKey': 'Mô hình đánh giá đã chọn không khả dụng',
    'Validations.InvalidObjectKey': 'ObjectKey là bắt buộc và phải khớp recordings/<userId>/<recordingId>.<ext>',
    'Validations.InvalidPractice': 'Bài luyện không phải là một giá trị hợp lệ',
    'Validations.InvalidReviewDuration': 'durationSeconds phải là một số dương',
    'Validations.InvalidSize': 'SizeBytes phải là một số byte dương',
    'Validations.InvalidThumbnailContentType': 'Ảnh thu nhỏ phải là hình ảnh (image/jpeg, image/png hoặc image/webp)',
    'Validations.InvalidThumbnailObjectKey': 'Cần có object key của ảnh thu nhỏ và phải khớp thumbnails/<userId>/<recordingId>.<ext>',
    'Validations.InvalidUploadParts': 'Mã tải lên và danh sách phần không mô tả một lần tải lên hợp lệ của bản thu này.',
    'Validations.NameContainsControlCharacters': 'Tên bản thu không được chứa ký tự điều khiển',
    'Validations.NameTooLong': 'Tên bản thu phải có tối đa {0} ký tự',
    'Validations.NoAiCreditsAvailable': 'Bạn cần tín dụng AI để tải bản thu lên cho đánh giá. Truy cập /pricing để nạp thêm tín dụng.',
    'Validations.NoRecordingToKeep': 'Không thể lưu vào thư viện của bạn — bản thu đã bị xóa hoặc chưa từng được tải lên',
    'Validations.NoRecordingToReview': 'Không thể bắt đầu đánh giá — bản thu chưa có tệp nào được tải lên',
    'Validations.NotesTooLong': 'Ghi chú bản thu phải có tối đa {0} ký tự',
    'Validations.QuotaExceeded': 'Bản thu này quá lớn so với dung lượng lưu trữ còn lại của bạn. Hãy giải phóng chỗ hoặc thêm dung lượng để giữ lại.',
    'Validations.RecordingUnavailable': 'Bản thu này không còn khả dụng — nó đã bị xóa',
    'Validations.ReviewUploadCannotBeSaved': 'Không thể lưu vào thư viện của bạn — lượt này chỉ được tải lên để AI đánh giá và chỉ được giữ tạm thời',
    'Validations.SaveRequiresPremium': 'Lưu bản thu vào thư viện của bạn là tính năng Cao cấp. Truy cập /pricing để nâng cấp.',
    'Validations.SelfReviewNeedsPlanTake': 'Lượt tự đánh giá chỉ được ghi nhận trên các bản thu được giữ trong kế hoạch thành thạo của bạn.',
    'Validations.SelfReviewRequiresPremium': 'Ghi nhận một lượt tự đánh giá là tính năng Cao cấp. Truy cập /pricing để nâng cấp.',
    'Validations.UnsupportedEffort': 'Mô hình đã chọn không hỗ trợ mức Nỗ lực này',
    'Validations.UploadTooLarge': 'Bản thu này vượt quá kích thước tải lên tối đa được hỗ trợ.',
    'Validations.UserMismatch': 'Bạn không thể thao tác trên bản thu của người dùng khác',
  },
} as const;

